import React from 'react';
import { Select, TextInput } from '@mantine/core';
import { Button } from '../../../components/Button';
import {
  DATE_FILTER_OPTIONS,
  ONTOPO_METHOD_OPTIONS,
  ONTOPO_STATUS_OPTIONS,
  type DateFilterMode,
} from '../monitoring-page.constants';
import type { UseMonitoringPage } from '../useMonitoringPage';
import classes from '../monitoring-page.module.scss';

type OntopoCallLogsFiltersProps = Pick<
  UseMonitoringPage,
  | 'ontopoTenantFilter' | 'setOntopoTenantFilter'
  | 'ontopoTenantOptions'
  | 'ontopoMethodFilter' | 'setOntopoMethodFilter'
  | 'ontopoStatusFilter' | 'setOntopoStatusFilter'
  | 'ontopoSearch' | 'setOntopoSearch'
  | 'ontopoDateFilterMode' | 'setOntopoDateFilterMode'
  | 'ontopoExactDate' | 'setOntopoExactDate'
  | 'ontopoDateFrom' | 'setOntopoDateFrom'
  | 'ontopoDateTo' | 'setOntopoDateTo'
  | 'clearOntopoFilters'
>;

export const OntopoCallLogsFilters: React.FC<OntopoCallLogsFiltersProps> = ({
  ontopoTenantFilter,
  setOntopoTenantFilter,
  ontopoTenantOptions,
  ontopoMethodFilter,
  setOntopoMethodFilter,
  ontopoStatusFilter,
  setOntopoStatusFilter,
  ontopoSearch,
  setOntopoSearch,
  ontopoDateFilterMode,
  setOntopoDateFilterMode,
  ontopoExactDate,
  setOntopoExactDate,
  ontopoDateFrom,
  setOntopoDateFrom,
  ontopoDateTo,
  setOntopoDateTo,
  clearOntopoFilters,
}) => (
  <div className={classes.filtersCard}>
    <div className={classes.filtersGridKitchen}>
      <div className={classes.fieldStack}>
        <Select
          label={'עסק'}
          placeholder={'בחר עסק'}
          data={ontopoTenantOptions}
          value={ontopoTenantFilter || null}
          onChange={(value) => setOntopoTenantFilter(value ?? '')}
          searchable
          clearable
          data-testid="monitoring-ontopo-filter-tenant"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'פעילות'}
          placeholder={'בחר פעילות'}
          data={ONTOPO_METHOD_OPTIONS}
          value={ontopoMethodFilter || null}
          onChange={(value) => setOntopoMethodFilter(value ?? '')}
          clearable
          data-testid="monitoring-ontopo-filter-method"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'סטטוס'}
          placeholder={'בחר סטטוס'}
          data={ONTOPO_STATUS_OPTIONS}
          value={ontopoStatusFilter || null}
          onChange={(value) => setOntopoStatusFilter(value ?? '')}
          clearable
          data-testid="monitoring-ontopo-filter-status"
        />
      </div>

      <div className={classes.fieldStack}>
        <TextInput
          label={'חיפוש'}
          placeholder={'שגיאה, הזמנה או שולחן'}
          value={ontopoSearch}
          onChange={(event) => setOntopoSearch(event.currentTarget.value)}
          data-testid="monitoring-ontopo-filter-search"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'סינון תאריך'}
          data={DATE_FILTER_OPTIONS}
          value={ontopoDateFilterMode}
          onChange={(value) => setOntopoDateFilterMode((value as DateFilterMode) ?? 'all')}
          allowDeselect={false}
          data-testid="monitoring-ontopo-date-mode"
        />
        {ontopoDateFilterMode === 'exact' && (
          <TextInput type="date" value={ontopoExactDate} onChange={(event) => setOntopoExactDate(event.currentTarget.value)} data-testid="monitoring-ontopo-date-exact" />
        )}
        {ontopoDateFilterMode === 'between' && (
          <div className={classes.fieldRow}>
            <TextInput type="date" value={ontopoDateFrom} onChange={(event) => setOntopoDateFrom(event.currentTarget.value)} data-testid="monitoring-ontopo-date-from" />
            <TextInput type="date" value={ontopoDateTo} onChange={(event) => setOntopoDateTo(event.currentTarget.value)} data-testid="monitoring-ontopo-date-to" />
          </div>
        )}
      </div>
    </div>

    <div className={classes.filtersActions}>
      <Button variant="cancel" onClick={clearOntopoFilters} dataTestId="monitoring-ontopo-clear-filters">
        {'נקה סינונים'}
      </Button>
    </div>
  </div>
);
